const R = 'ready';
export const warehouseNav = [
    {
        label: 'Godown stock', path: '/erp/warehouse', module: 'erp.warehouse.stock', icon: 'Warehouse', status: R, matchPrefix: true,
        keywords: 'stock batch transfer transit adjustment physical verification count location rack bin movement stock transfer stock adjustment godown depot',
    },
];
//# sourceMappingURL=warehouse.js.map